enum Action {
  FETCH_SIDEBAR_DATA = 'fetchSidebarData',
}

export default Action;
